// AvatarEditor.tsx - Componente funcional completo con los 4 pasos

import { useEffect, useRef, useState } from "react";
import UiAvatarEditor from "react-avatar-editor";
import { useDispatch } from "react-redux";
import { hideModal, showModal } from "../../../store/actions/modal";
import constants from "../../../constants";
import Modal from "../../Modal";
import defaultAvatarImage from "../../../assets/icons/avatar.svg";
import checkIcon from "../../../assets/check-bold.svg";
import ModalAvatar from './components/ModalAvatar'
import Icon from "../../Icon";
import Spinner from "../../LogoLoader";
import pencil from "../../../assets/pencil.svg";

import {
  Avatar,
  AvatarEditorStyled,
  UserAvatar,
  UserAvatarContainer,
  AvatarCta,
  UpdatePicture,
  Cancel,
  SavePicture,
  Editor,
  Actions,
  ValidationError,
  Zoom,
  Rotate,
  Title,
  Subtitle,
  SuccessIcon,
} from "./styles";
import { UseFormSetValue } from "react-hook-form";

const errorMessages = {
  extensionError: "Formatos permitidos .JPEG y .PNG",
  sizeError: "El peso de la imagen debe ser menor a 5Mb",
};

const isValidExtension = (event) => {
  const ext = event.target.files[0]?.name?.split(".").pop();
  return constants.userAvatar.validExtensions.includes(ext);
};

const isValidSize = (event) =>
  event.target.files[0].size / 1024 / 1024 < constants.userAvatar.maxSize;

interface AvatarEditorProps {
  picture: any;
  onSave: () => void;
  register: any;
  name: string;
  setValue: UseFormSetValue<any>
  errors: Record<string, any>;
  loading: boolean;
}

const AvatarEditor = ({ picture, onSave, register, name, setValue, errors, loading }: AvatarEditorProps) => {
  const dispatch = useDispatch();
  const avatarEditorRef = useRef<UiAvatarEditor | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const zoomInputRef = useRef<HTMLInputElement | null>(null);
  const degInputRef = useRef<HTMLInputElement | null>(null);

  const [userAvatar, setUserAvatar] = useState(defaultAvatarImage);
  const [editingImage, setEditingImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [deg, setDeg] = useState(1);
  const [withError, setWithError] = useState<keyof typeof errorMessages | null>(null);
  const [step, setStep] = useState(1);
  const [success, setSuccess] = useState(false);

  const resetEdition = () => {
    setZoom(1);
    setEditingImage(null);
    setWithError(null);
    setStep(1);
    setSuccess(false);
  };

  const handlePictureChange = (event) => {
    const image = event.target.files[0];
    if (!isValidExtension(event)) return setWithError("extensionError");
    if (!isValidSize(event)) return setWithError("sizeError");
    setEditingImage(image);
    setWithError(null);
    setStep(2);
  };

  const handleCropConfirm = () => {
    if (!avatarEditorRef.current) return;
    const preview = avatarEditorRef.current.getImage().toDataURL();
    setUserAvatar(preview);
    setValue(name, preview);
    setStep(3);
  };

  const handleFinalSubmit = () => {
    if (onSave) onSave();
    setSuccess(true);
    setStep(4);
  };

  const handleCancel = () => {
    dispatch(hideModal());
    resetEdition();
  };

  useEffect(() => {
    if (picture) setUserAvatar(picture);
  }, [picture]);

  return (
    <>
      <Avatar>
        <UserAvatarContainer>
          <UserAvatar
            src={userAvatar}
            alt="Avatar"
            width="auto"
            height="100%"
            hasError={!!errors[name]}
          />
        </UserAvatarContainer>

        <AvatarCta type="button" onClick={() => {
          setStep(1)
          dispatch(showModal("avatar-editor"))
        }}>
          <Icon icon={pencil} size="16px" color="#6C5CE7" />
        </AvatarCta>

        {loading && (
          <span style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner />
          </span>
        )}
      </Avatar>

      {/* <ModalAvatar picture={picture} onSave={onSave} register={register} name={name} setValue={setValue} errors={errors} loading={loading} /> */}
    </>
  );
};

export default AvatarEditor;
